import { useTour } from '@reactour/tour';
import { useEffect } from 'preact/hooks';

import { useSelector } from '@/redux/helper';
import { selectCanAccessEducatorsApp, selectHasGuidedExperienceFeature } from '@/redux/selectors/users';

const useHabitatTour = () => {
  const { setIsOpen } = useTour();
  const canAccessEducatorsApp = useSelector(selectCanAccessEducatorsApp);
  const educatorOnboarding = useSelector((state) => state.user.educatorOnboarding);
  const hasActiveL1Plan = useSelector(selectHasGuidedExperienceFeature);

  useEffect(() => {
    if (hasActiveL1Plan) {
      setIsOpen(false);
      return undefined;
    }

    const hasNotCompleted = !educatorOnboarding?.isOnboardingCompleted;
    const hasNotSkipped = !educatorOnboarding?.isOnboardingSkipped;
    const shouldShowTour = canAccessEducatorsApp && hasNotCompleted && hasNotSkipped;

    if (!shouldShowTour) {
      return undefined;
    }
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, [setIsOpen, canAccessEducatorsApp, educatorOnboarding, hasActiveL1Plan]);
};

export default useHabitatTour;
